@if (sessions.length === 0) {
  <div class="empty-sessions">
    <mat-icon class="empty-icon">chat_bubble_outline</mat-icon>
    <p>{{ emptyMessageKey | translate }}</p>
  </div>
}

@if (sessions.length > 0) {
  <div>
    <div class="session-list-header">
      @if (!pendingDeleteAll) {
        <button
          mat-stroked-button
          color="warn"
          (click)="askDeleteAll()"
          >
          <mat-icon>delete_sweep</mat-icon>
          {{ 'colimind.deleteAll' | translate }}
        </button>
      }
      @if (pendingDeleteAll) {
        <div class="delete-confirm">
          <span class="delete-confirm-text">{{ 'colimind.deleteAllConfirm' | translate }}</span>
          <button
            mat-icon-button
            color="warn"
            [matTooltip]="'colimind.confirm' | translate"
            (click)="confirmDeleteAll()"
            >
            <mat-icon>check</mat-icon>
          </button>
          <button
            mat-icon-button
            [matTooltip]="'colimind.cancel' | translate"
            (click)="cancelDelete($event)"
            >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </div>
    @for (session of sessions; track session.session_id) {
      <div
        class="session-item"
        [class.session-item--active]="session.session_id === activeSessionId"
        (click)="selectSession.emit(session.session_id)"
        >
        <mat-icon class="session-icon">chat_bubble_outline</mat-icon>
        <div class="session-info">
          <p class="session-title" [matTooltip]="session.title">{{ session.title }}</p>
          <p class="session-meta">
            {{ formatDate(session.created_at) }}
          </p>
          <p class="session-meta">
            {{ msgCount(session) }} msgs
          </p>
          @if (session.snippet) {
            <p class="session-snippet">
              "{{ session.snippet }}"
            </p>
          }
        </div>
        @if (pendingDeleteId !== session.session_id) {
          <button
            mat-icon-button
            class="session-delete"
            [matTooltip]="('colimind.deleteSession' | translate) || 'Delete'"
            (click)="askDelete($event, session.session_id)"
            >
            <mat-icon>close</mat-icon>
          </button>
        }
        @if (pendingDeleteId === session.session_id) {
          <div class="delete-confirm">
            <span class="delete-confirm-text">{{ 'colimind.deleteSessionConfirm' | translate }}</span>
            <button
              mat-icon-button
              color="warn"
              [matTooltip]="'colimind.confirm' | translate"
              (click)="confirmDelete($event, session.session_id)"
              >
              <mat-icon>check</mat-icon>
            </button>
            <button
              mat-icon-button
              [matTooltip]="'colimind.cancel' | translate"
              (click)="cancelDelete($event)"
              >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
      </div>
    }
  </div>
}
